import router from './router'
import store from './store'
import { Message, MessageBox } from 'element-ui'
import axios from 'axios'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import md5 from 'js-md5';
import { setRouterHash,getRouterHash,getToken } from '@/utils/auth' // getToken from cookie

NProgress.configure({ showSpinner: false })// NProgress configuration

const whiteList = ['/login','/register'] // 不重定向白名单

router.beforeEach((to, from, next) => {
  if(store.getters.router && !store.getters.router.length){
    store.dispatch("Router")
  }
  NProgress.start()
  if(to.meta.breadcrumb){
    document.title = '四川长江经济研究院 - ' + to.meta.breadcrumb;
  }else{
    document.title = '四川长江经济研究院'
  }
  if(to.meta.keywords){
    document.querySelector('meta[name="keywords"]').setAttribute('content','四川长江经济研究院|'+to.meta.keywords)
  }else{
    if(to.meta.breadcrumb){
      document.querySelector('meta[name="keywords"]').setAttribute('content','四川长江经济研究院|'+to.meta.breadcrumb)
    }else{
      document.querySelector('meta[name="keywords"]').setAttribute('content','四川长江经济研究院')
    }
  }
  if(to.meta.description){
    document.querySelector('meta[name="description"]').setAttribute('content',to.meta.description)
  }else{
    if(to.meta.breadcrumb){
      document.querySelector('meta[name="description"]').setAttribute('content','四川长江经济研究院|'+to.meta.breadcrumb)
    }else{
      document.querySelector('meta[name="description"]').setAttribute('content','四川长江经济研究院')
    }
  }
  if (getToken()) {
    if (to.path === '/login' || to.path === '/register') {
      if (store.getters.userInfo && !store.getters.userInfo.token){
        next()
      }else{
        next({ path: '/' })
      }
      NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      if (store.getters.userInfo && !store.getters.userInfo.token) {
        store.dispatch('GetInfo').then(res => { // 拉取用户信息
          next()
        }).catch((err) => {
          if (to.meta.isLogin) {
            store.dispatch('FedLogOut').then(() => {
              console.error(err || 'Verification failed, please login again')
              next({ path: '/' })
            })
          }else{
            next()
          }
        })
      } else {
        next()
      }
    }
  } else {
    if (to.meta.isLogin) {
        if (whiteList.indexOf(to.path) !== -1) {
          next()
        } else {
          next(`/login?redirect=${to.path}`) // 否则全部重定向到登录页
          NProgress.done()
        }
    }else{
      next()
      NProgress.done()
    }
   
  }
  
  
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/permission.js